export default __webpack_public_path__ + "static/media/15.b1269a24.jpg";